import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import { FaSearch, FaHeadset } from 'react-icons/fa';

const SupervisorNavbar = ({ toggleSidebar }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="bg-white shadow-sm border-b border-[rgba(0,119,182,0.1)]"
    >
      <div className="px-2 sm:px-4 lg:px-8">
        <div className="flex justify-between h-12 sm:h-16 items-center">
          <div className="flex items-center space-x-2 sm:space-x-4">
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={toggleSidebar}
              className="text-[#333333] hover:text-[#0077B6] focus:outline-none p-1"
              aria-label="Toggle sidebar"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 sm:h-6 sm:w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </motion.button>
            <div className="relative max-w-xs w-full hidden sm:block">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FaSearch className="h-4 w-4 sm:h-5 sm:w-5 text-gray-400" />
              </div>
              <input
                type="text"
                placeholder="Search reviews..."
                className="block w-full pl-8 sm:pl-10 pr-3 py-1.5 sm:py-2 border border-gray-300 rounded-lg bg-white text-xs sm:text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#20B2AA] focus:border-[#20B2AA] transition-colors"
              />
            </div>
          </div>
          <div className="flex items-center space-x-1 sm:space-x-4">
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="hidden sm:block"
            >
              <Link
                to="/support"
                state={{ from: location.pathname }}
                className="flex items-center text-[#333333] hover:text-[#0077B6] transition-colors"
                title="Get Support"
              >
                <FaHeadset className="h-4 w-4 sm:h-5 sm:w-5" />
                <span className="ml-2 text-xs sm:text-sm font-medium hidden md:inline">Support</span>
              </Link>
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center space-x-1 sm:space-x-2"
            >
              <Link to="/profile" className="flex items-center">
                <div className="h-6 w-6 sm:h-8 sm:w-8 rounded-full bg-[rgba(0,119,182,0.1)] flex items-center justify-center text-[#0077B6] text-xs sm:text-sm">
                  {user?.name?.charAt(0) || 'S'}
                </div>
                <span className="ml-1 sm:ml-2 text-xs sm:text-sm font-medium text-[#333333] hidden lg:inline">
                  {user?.name || 'Supervisor'}
                </span>
              </Link>
            </motion.div>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={logout}
              className="bg-gradient-to-r from-[#0077B6] to-[#20B2AA] text-white px-2 sm:px-4 py-1.5 sm:py-2 rounded-full font-medium text-xs sm:text-sm transition-all duration-300 shadow-md hover:shadow-lg"
            >
              <span className="hidden sm:inline">Logout</span>
              <span className="sm:hidden">Out</span>
            </motion.button>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default SupervisorNavbar;
